// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"Container-module--containerBox--1wOO5","container":"Container-module--container--3KHiT"};